import { Component } from '@angular/core';

@Component({
  selector: 'app-sites-page',
  templateUrl: './sites-page.component.html',
  styleUrls: ['./sites-page.component.scss'],
})
export class SitesPageComponent {}
